module.exports = __webpack_public_path__ + "static/media/promo1.ba324243.jpg";